// Services
import DeviceService from "../fhir/DeviceService";
// Mappers
import { mapDeviceGatewayLinks, mapDeviceToInformationSystemNode } from "./InformationSystemMapping.mappers";
// Types
import { InformationSystemMap, InformationSystemNode } from "./InformationSystemMapping.types";

export default class InformationSystemMappingService {
    constructor(private readonly deviceService: DeviceService) {}

    async getSoftwareMap(): Promise<InformationSystemMap> {
        const devices = await this.deviceService.searchSoftwareDevices();
        const nodes = devices.map(mapDeviceToInformationSystemNode);
        const links = devices.flatMap(mapDeviceGatewayLinks);
        const nodesWithMissingGatewayTargets = this.getMissingGatewayTargetNodes(nodes, links);

        return {
            nodes: [...nodes, ...nodesWithMissingGatewayTargets],
            links,
        };
    }

    private getMissingGatewayTargetNodes(
        nodes: InformationSystemNode[],
        links: InformationSystemMap["links"]
    ): InformationSystemNode[] {
        const knownNodeIds = new Set(nodes.map((node) => node.id));
        const missingTargetIds = links
            .map((link) => link.targetDeviceId)
            .filter((targetId, index, targetIds) => targetIds.indexOf(targetId) === index)
            .filter((targetId) => !knownNodeIds.has(targetId));

        return missingTargetIds.map((targetId) => ({
            id: targetId,
            name: targetId,
            status: "unknown",
        }));
    }
}
